import { GridRowProps } from "@mui/x-data-grid";
import { useTranslation } from "../../../../../hooks";
import { selectCrossMerchant } from "../../../../../reducer/crossMerchantSlice";
import { useAppSelector } from "../../../../../reducer/hooks";
import {
  findChainInfo,
  listMappingTransform,
  toDisplayTime,
} from "../../../../../utils/helper";
import {
  translatePrefix,
  translateKeyObj as TK,
  ITableRes,
} from "../../config";

const useListMapping = () => {
  const { t } = useTranslation(translatePrefix);

  const { merchantMapping } = useAppSelector(selectCrossMerchant);

  const listMapping = (
    which: "key" | "name",
    array: ITableRes[],
    config?: { omitKeys: string[] }
  ): GridRowProps[] => {
    const { omitKeys = [] } = config || {};
    const res = array.map((item: ITableRes) => {
      const { name: from_chain_name } =
        findChainInfo(item.from_chain_type, item.from_chain_id) ?? {};

      const { name: to_chain_name } =
        findChainInfo(item.to_chain_type, item.to_chain_id) ?? {};

      const getMerchantName = (merchantId: string) =>
        merchantMapping[merchantId];

      const exchangeRate =
        item?.cross_merchant_transfer_exchange_rate?.exchange_rate ?? "";
      const exchangeRateLastModifiedDate =
        item?.cross_merchant_transfer_exchange_rate?.last_modified_date;

      const mappedResult: [string, string, any][] = [
        [
          TK.merchantFrom,
          t(TK.merchantFrom),
          getMerchantName(item.from_merchant_id),
        ],
        [TK.chainNameFrom, t(TK.chainNameFrom), from_chain_name],
        [TK.currencyFrom, t(TK.currencyFrom), item.from_asset_name],
        [TK.merchantTo, t(TK.merchantTo), getMerchantName(item.to_merchant_id)],
        [TK.chainNameTo, t(TK.chainNameTo), to_chain_name],
        [TK.currencyTo, t(TK.currencyTo), item.to_asset_name],
        [
          TK.merchantLp,
          t(TK.merchantLp),
          getMerchantName(item.liquidity_provider_merchant_id),
        ],
        [
          TK.liquidityProvider,
          t(TK.liquidityProvider),
          item.liquidity_provider,
        ],
        [TK.exchangeRate, t(TK.exchangeRate), exchangeRate],
        [TK.creationTime, t(TK.creationTime), toDisplayTime(item.created_date)],
        [
          TK.lastModifiedTime,
          t(TK.lastModifiedTime),
          toDisplayTime(item.last_modified_date),
        ],
        [
          TK.lastModifiedTimeExchangeRate,
          t(TK.lastModifiedTimeExchangeRate),
          toDisplayTime(exchangeRateLastModifiedDate ?? ""),
        ],
        ["rawData", "", item],
      ];

      const filteredResult = mappedResult.filter(
        ([key]) => !omitKeys.includes(key)
      );

      return filteredResult;
    });

    const output = res.map(listMappingTransform(which));
    return output;
  };

  return listMapping;
};
export default useListMapping;
